import React, { useContext, useState, useEffect, useRef } from "react";
import TabelaDeContratos from "../Tabelas/TabelaContratos";
import * as D from "./DashboardStyle";
import { AuthContext } from "../../context/AuthContext";
import { abreviarNome, formatNumber } from "../../assets/utils";
import SideBarBox from "../Sidebar/SideBarBox";
import GoldPriceChart from "../GoldPriceChart/GoldPriceChart";
import AnimatedProgressBar from "../AnimatedProgressBar/AnimatedProgressBar";
import useCountUp from "../../hooks/useCountUp";
import Warning from "./Warning/Warning";
import Warning2 from "./Warning/Warning2";
import WarningComunicado from "./Warning/WarningComunicado";
import WarningRedes from "./Warning/WarningRedes";
import WarningTransparencia from "./Warning/WarningTransparencia";
import BannerDaniel from "./BannerDaniel/BannerDaniel";
import GoldenMiniLogo from "../GoldenMiniLogo/GoldenMiniLogo";
import { goldenBoxService } from "../../Services/goldenBoxService";
import {
  FaFileContract,
  FaMoneyBillWave,
  FaChartLine,
  FaUsers,
  FaTrophy,
  FaArrowRight,
  FaSpinner,
  FaCrown,
  FaInfoCircle,
  FaTimes,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const GOLDEN_BOX_WARNING_KEY = "goldenBoxWarningLastSeen";
const EXCLUSIVE_FORM_WARNING_KEY = "exclusiveFormWarningLastSeen";
const BANNER_DANIEL_SEEN_KEY = "bannerDanielSeen";
const COMUNICADO_WARNING_SEEN_KEY = "comunicadoWarningSeen_setembro";
const REDES_WARNING_SEEN_KEY = "redesWarningSeen";
const TRANSPARENCIA_WARNING_SEEN_KEY = "transparenciaWarningSeen_setembro";
const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

// Último instante de dezembro/2025 (fim do dia 31/12/2025).
const COMUNICADO_DATE_LIMIT = new Date("2025-12-31T23:59:59");

export default function Dashboard() {
  const { userData, platformData, contracts } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [showWarning, setShowWarning] = useState(false);
  const [showWarning2, setShowWarning2] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  const [activeVaultTab, setActiveVaultTab] = useState(0);
  const [vaultData, setVaultData] = useState(null);
  const [vaultLoading, setVaultLoading] = useState(true);
  const [showVipModal, setShowVipModal] = useState(false);
  const [showBannerDaniel, setShowBannerDaniel] = useState(false);
  const [showComunicado, setShowComunicado] = useState(false);
  const [showRedes, setShowRedes] = useState(false);
  const [showTransparencia, setShowTransparencia] = useState(false);
  const tabelaContainerRef = useRef(null);

  useEffect(() => {
    const fetchVaultData = async () => {
      if (userData?.id) {
        try {
          setVaultLoading(true);
          const data = await goldenBoxService.getDashboardData(userData.id);
          setVaultData(data);
        } catch (error) {
          console.error(error);
        } finally {
          setVaultLoading(false);
        }
      }
    };
    fetchVaultData();
  }, [userData]);

  const vaultOptions = [
    {
      id: 0,
      label: "Saque Anual",
      saldo:
        vaultData?.saqueAnualInfo?.totalAmountReceivedActivedGoldenBoxes || 0,
      proximoSaque: vaultData?.saqueAnualInfo?.mostCloseWithdrawDate,
      bonusPrevisto: vaultData?.saqueAnualInfo?.actualTotalMonthlyBonus || 0,
      qtdContratos: vaultData?.saqueAnualInfo?.totalContracts || 0,
    },
    {
      id: 1,
      label: "Fim de Contrato",
      saldo:
        vaultData?.saqueNoFimInfo?.totalAmountReceivedActivedGoldenBoxes || 0,
      proximoSaque: vaultData?.saqueNoFimInfo?.mostCloseWithdrawDate,
      bonusPrevisto: vaultData?.saqueNoFimInfo?.actualTotalMonthlyBonus || 0,
      qtdContratos: vaultData?.saqueNoFimInfo?.totalContracts || 0,
    },
  ];

  const currentVaultData = vaultOptions[activeVaultTab];
  const animatedCaixinhaBalance = useCountUp(currentVaultData.saldo);
  const animatedActiveContracts = useCountUp(platformData?.activeContracts);
  const animatedPlatformBalance = useCountUp(
    (platformData?.purchaseTotalBalance || 0) +
      (platformData?.platformWithdrawAvaliable || 0)
  );
  const animatedPurchaseBalance = useCountUp(
    platformData?.purchaseTotalBalance
  );
  const animatedProfitBalance = useCountUp(
    platformData?.platformWithdrawAvaliable
  );
  const animatedSponsorCredit = useCountUp(userData?.sponsorCredit);

  useEffect(() => {
    if (userData && platformData) {
      setLoading(false);
      setTimeout(() => setIsVisible(true), 100);
    }
  }, [userData, platformData]);

  const checkAndShowWarnings = (contractsData) => {
    const currentTime = Date.now();
    const lastSeen1 = sessionStorage.getItem(GOLDEN_BOX_WARNING_KEY);
    const lastSeen2 = sessionStorage.getItem(EXCLUSIVE_FORM_WARNING_KEY);
    const isTimeElapsed1 =
      !lastSeen1 || currentTime - parseInt(lastSeen1, 10) > ONE_DAY_IN_MS;
    const isTimeElapsed2 =
      !lastSeen2 || currentTime - parseInt(lastSeen2, 10) > ONE_DAY_IN_MS;

    const hasEligibleContract =
      contractsData &&
      contractsData.some((c) => c.contract?.status === 1 || c.contract?.status === 2);

    if (isTimeElapsed1 && hasEligibleContract) {
      setShowWarning(true);
      setShowWarning2(false);
    } else if (isTimeElapsed2) {
      setShowWarning(false);
      setShowWarning2(true);
    } else {
      setShowWarning(false);
      setShowWarning2(false);
    }
  };

  useEffect(() => {
    if (!userData) return;
    checkAndShowWarnings(contracts);
  }, [userData, contracts]);

  // Comunicado: aparece para qualquer cliente com contrato ativo (status 1 ou 2).
  const isEligibleForComunicado = (contractsData) => {
    return (contractsData || []).some(
      (c) => c.contract?.status === 1 || c.contract?.status === 2
    );
  };

  useEffect(() => {
    if (!userData) return;
    if (sessionStorage.getItem(COMUNICADO_WARNING_SEEN_KEY)) return;
    setShowComunicado(isEligibleForComunicado(contracts));
  }, [userData, contracts]);

  const handleCloseComunicado = () => {
    setShowComunicado(false);
    sessionStorage.setItem(COMUNICADO_WARNING_SEEN_KEY, "true");
  };

  // Comunicado sobre indisponibilidade dos perfis nas redes sociais (Meta).
  // Desativado a pedido do cliente — componente WarningRedes mantido pra
  // eventual reativação futura, basta descomentar o setShowRedes(true).
  useEffect(() => {
    if (!userData) return;
    if (sessionStorage.getItem(REDES_WARNING_SEEN_KEY)) return;
    // setShowRedes(true);
  }, [userData]);

  const handleCloseRedes = () => {
    setShowRedes(false);
    sessionStorage.setItem(REDES_WARNING_SEEN_KEY, "true");
  };

  // Comunicado sobre transparência, segurança e regularização (jul/2026).
  // Desativado a pedido do cliente — mantido apenas o WarningComunicado.
  useEffect(() => {
    if (!userData) return;
    if (sessionStorage.getItem(TRANSPARENCIA_WARNING_SEEN_KEY)) return;
    // setShowTransparencia(true);
  }, [userData]);

  const handleCloseTransparencia = () => {
    setShowTransparencia(false);
    sessionStorage.setItem(TRANSPARENCIA_WARNING_SEEN_KEY, "true");
  };

  const handleCloseWarning = () => {
    setShowWarning(false);
    sessionStorage.setItem(GOLDEN_BOX_WARNING_KEY, Date.now().toString());
    checkAndShowWarnings(contracts);
  };

  const handleCloseWarning2 = () => {
    setShowWarning2(false);
    sessionStorage.setItem(EXCLUSIVE_FORM_WARNING_KEY, Date.now().toString());
  };

  const handleCloseBannerDaniel = () => {
    setShowBannerDaniel(false);
  };

  // BannerDaniel pausado: não exibir ao rolar até a tabela de contratos.
  // useEffect(() => {
  //   if (loading) return;
  //   if (sessionStorage.getItem(BANNER_DANIEL_SEEN_KEY)) return;
  //
  //   const target = tabelaContainerRef.current;
  //   if (!target) return;
  //
  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         if (entry.isIntersecting) {
  //           setShowBannerDaniel(true);
  //           sessionStorage.setItem(BANNER_DANIEL_SEEN_KEY, "true");
  //           observer.disconnect();
  //         }
  //       });
  //     },
  //     { threshold: 0.2 }
  //   );
  //
  //   observer.observe(target);
  //   return () => observer.disconnect();
  // }, [loading]);

  const handleAcceptGoldenBox = () => {
    handleCloseWarning();
    navigate("/caixinha");
  };

  const renderDate = (dateString) => {
    if (!dateString) return "Sem previsão";
    try {
      return new Date(dateString).toLocaleDateString("pt-BR");
    } catch {
      return "Data Inválida";
    }
  };

  if (loading || !platformData) return null;

  return (
    <SideBarBox>
      {showRedes && <WarningRedes onClose={handleCloseRedes} />}
      {showTransparencia && (
        <WarningTransparencia onClose={handleCloseTransparencia} />
      )}

      {showWarning && (
        <Warning
          onClose={handleCloseWarning}
          onAccept={handleAcceptGoldenBox}
        />
      )}

      {showComunicado && (
        <WarningComunicado onClose={handleCloseComunicado} />
      )}

      {/* BannerDaniel pausado */}
      {/* {showBannerDaniel && <BannerDaniel onClose={handleCloseBannerDaniel} />} */}

      {showVipModal && (
        <D.ModalOverlay onClick={() => setShowVipModal(false)}>
          <D.ModalContent onClick={(e) => e.stopPropagation()}>
            <D.CloseModalButton onClick={() => setShowVipModal(false)}>
              <FaTimes />
            </D.CloseModalButton>
            <FaCrown
              style={{
                fontSize: "40px",
                color: "#ffd700",
                marginBottom: "15px",
              }}
            />
            <h3>Cliente VIP Golden Brasil</h3>
            <p>
              Os <strong>Clientes VIP da Golden Brasil</strong> são clientes que
              têm acesso a valorização exclusiva na compra de seus contratos de{" "}
              <strong>4,1% ao mês</strong>.
            </p>
          </D.ModalContent>
        </D.ModalOverlay>
      )}

      <D.DashboardContainer>
        <D.PrincipalContent
          style={{
            opacity: isVisible ? 1 : 0,
            transition: "opacity 0.5s ease-in",
          }}
        >
          <D.SaldacoesUsuario>
            <span>
              OLÁ {abreviarNome((userData?.name || "").toUpperCase())}
            </span>
            {userData?.isVipClient && (
              <D.VipContainer>
                <D.VipBadge>
                  <FaCrown />
                  Cliente VIP
                </D.VipBadge>
                <D.VipInfoIcon onClick={() => setShowVipModal(true)}>
                  <FaInfoCircle />
                </D.VipInfoIcon>
              </D.VipContainer>
            )}
          </D.SaldacoesUsuario>

          <D.ContainerContent>
            <D.MainStatCard>
              <D.MainIconBox>
                <FaTrophy />
              </D.MainIconBox>
              <div style={{ flex: 1 }}>
                <D.StatTitleSub>SALDO TOTAL NA PLATAFORMA</D.StatTitleSub>
                <D.MainStatValue>
                  R$ {formatNumber(animatedPlatformBalance)}
                </D.MainStatValue>
              </div>
            </D.MainStatCard>

            <D.BartIsTheBestFriend>
              <D.StatsGrid>
                <D.StatCard>
                  <D.IconBox gradient="linear-gradient(135deg, #3b82f6, #2563eb)">
                    <FaFileContract />
                  </D.IconBox>
                  <div className="stat-content">
                    <D.StatTitle>CONTRATOS ATIVOS</D.StatTitle>
                    <D.StatValue>{animatedActiveContracts}</D.StatValue>
                  </div>
                </D.StatCard>
                <D.StatCard>
                  <D.IconBox gradient="linear-gradient(135deg, #f59e0b, #d97706)">
                    <FaMoneyBillWave />
                  </D.IconBox>
                  <div className="stat-content">
                    <D.StatTitle>VALOR DE COMPRA</D.StatTitle>
                    <D.StatValue>
                      R$ {formatNumber(animatedPurchaseBalance)}
                    </D.StatValue>
                  </div>
                </D.StatCard>
                <D.StatCard>
                  <D.IconBox gradient="linear-gradient(135deg, #10b981, #059669)">
                    <FaChartLine />
                  </D.IconBox>
                  <div className="stat-content">
                    <D.StatTitle>VALOR VALORIZADO</D.StatTitle>
                    <D.StatValue>
                      R$ {formatNumber(animatedProfitBalance)}
                    </D.StatValue>
                  </div>
                </D.StatCard>
                <D.StatCard>
                  <D.IconBox gradient="linear-gradient(135deg, #8b5cf6, #7c3aed)">
                    <FaUsers />
                  </D.IconBox>
                  <div className="stat-content">
                    <D.StatTitle>SALDO DE INDICAÇÃO</D.StatTitle>
                    <D.StatValue>
                      R$ {formatNumber(animatedSponsorCredit)}
                    </D.StatValue>
                  </div>
                </D.StatCard>
              </D.StatsGrid>

              <D.GoldenVaultCard>
                <D.VaultHeader>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <h3>Golden Box - Caixa de Ouro</h3>
                    <D.VaultToggleContainer>
                      {vaultOptions.map((option) => (
                        <D.VaultToggleButton
                          key={option.id}
                          active={activeVaultTab === option.id}
                          onClick={() => setActiveVaultTab(option.id)}
                          disabled={vaultLoading}
                        >
                          {option.label}
                        </D.VaultToggleButton>
                      ))}
                    </D.VaultToggleContainer>
                  </div>
                  <D.VaultIconWrapper>
                    {vaultLoading ? (
                      <FaSpinner className="spinner" />
                    ) : (
                      <GoldenMiniLogo />
                    )}
                  </D.VaultIconWrapper>
                </D.VaultHeader>
                {vaultLoading ? (
                  <D.VaultLoadingState>
                    <p>Carregando dados da caixinha...</p>
                  </D.VaultLoadingState>
                ) : (
                  <>
                    <D.VaultMainValue>
                      <span>Saldo {currentVaultData.label}</span>
                      <h1 key={activeVaultTab}>
                        R$ {formatNumber(animatedCaixinhaBalance)}
                      </h1>
                    </D.VaultMainValue>
                    <D.VaultInfoGrid>
                      <div className="info-item">
                        <small>Contratos Configurados</small>
                        <strong>{currentVaultData.qtdContratos} Und.</strong>
                      </div>
                      <div className="info-item right">
                        <small>Próximo Saque</small>
                        <strong>
                          {renderDate(currentVaultData.proximoSaque)}
                        </strong>
                      </div>
                    </D.VaultInfoGrid>
                  </>
                )}
              </D.GoldenVaultCard>
            </D.BartIsTheBestFriend>

            <AnimatedProgressBar
              title="Saldo Disponível para Saque"
              value={platformData.platformWithdrawAvaliable}
              total={
                (platformData.purchaseTotalBalance || 0) +
                (platformData.platformWithdrawAvaliable || 0)
              }
              currency={true}
            />

            <D.AdvertisingBanner onClick={() => navigate("/novacompra")}>
              <div className="content-side">
                <h2>VALORIZE SEU CAPITAL</h2>
                <p>
                  Valorização garantida de até <strong>4,1% ao mês</strong> em
                  Minérios.
                </p>
              </div>
              <div className="action-side">
                <button>
                  COMPRAR AGORA <FaArrowRight />
                </button>
              </div>
            </D.AdvertisingBanner>

            <D.AdvertisingBanner onClick={() => navigate("/caixinha")}>
              <div className="content-side">
                <h2>VALORIZE AINDA MAIS EM SEUS CONTRATOS</h2>
                <p>
                  UM TOTAL DE <strong>12% ou 46%</strong> a mais de bônus e{" "}
                  <strong>SAQUES MENSAIS</strong>.
                </p>
              </div>
              <div className="action-side">
                <button>
                  QUERO ATIVAR MINHA CAIXINHA <FaArrowRight />
                </button>
              </div>
            </D.AdvertisingBanner>

            <GoldPriceChart />

            <D.ThirdRow>
              <h2>TABELA DE CONTRATOS</h2>
            </D.ThirdRow>
            <D.TabelaContainer ref={tabelaContainerRef}>
              <TabelaDeContratos />
            </D.TabelaContainer>
          </D.ContainerContent>
        </D.PrincipalContent>
      </D.DashboardContainer>
    </SideBarBox>
  );
}
